export async function loadStatus(type, nalObject) {
    if (!_(nalObject).has(`firm.firm_settings.statuses.${type}`)) {
        try {
            const response = await $.get({
                url: `/api/statuses/${type}`,
                contentType: 'application/json',
            });

            createStatusObject(nalObject);
            window.setVueObject(nalObject.firm.firm_settings.statuses, type, response.data);
        } catch (error) {
            handleError(error);
        }
    }
}

// Requires statuses to be in an array of strings e.g. ['candidates', 'clients', 'assignments', ...]
export async function loadStatuses(statusesArray, nalObject) {
    const filteredStatuses = getStatusesToLoad(statusesArray, nalObject);
    if (filteredStatuses.length) {
        const statusesUrl = filteredStatuses.toString();
        try {
            const response = await $.get({
                url: `/api/statuses/types?types=${statusesUrl}`,
                contentType: 'application/json',
            });

            createStatusObject(nalObject);

            Object.keys(response.data).forEach(type => {
                window.setVueObject(nalObject.firm.firm_settings.statuses, type, response.data[type]);
            });
        } catch (error) {
            handleError(error);
        }
    }
}

function createStatusObject(nalObject) {
    if (!nalObject.firm.firm_settings.statuses) {
        window.setVueObject(nalObject.firm.firm_settings, 'statuses', {});
    }
}

function getStatusesToLoad(statusesArray, nalObject) {
    return statusesArray.filter(type => {
        return (!_(nalObject).has(`firm.firm_settings.statuses.${type}`));
    });
}

function handleError(error, nalObject) {
    if (nalObject && (nalObject.project === 'nal')) {
        if (error.status === 500) {
            window.notify(trans('nal-lang.error.general-error'), 'alert');
        }
    }
}

export function loadBillingStatuses(nalObject) {
    const billingStatuses = ['revenues', 'invoices', 'invoiceItems', 'percentSplits', 'fixedFees'];
    loadStatuses(billingStatuses, nalObject);
}
